<section class="flex flex-col gap-12">
  <app-section-header
    [description]="
      'See how Capawesome Cloud compares to Ionic Appflow across key features and pricing'
    "
    [icon]="'@tui.table'"
    [subtitle]="'Comparison'"
    [title]="'Capawesome Cloud vs Ionic Appflow'"
  >
  </app-section-header>

  <div class="w-full overflow-x-auto">
    <div class="min-w-[600px]">
      <!-- Table Header -->
      <div class="mb-6 grid grid-cols-3 gap-4 border-b border-gray-200 pb-4">
        <div class="text-left">
          <h3 class="text-lg font-semibold text-gray-600">Feature</h3>
        </div>
        <div class="text-center">
          <div class="flex flex-col items-center">
            <h3 class="text-lg font-bold text-primary">Capawesome Cloud</h3>
          </div>
        </div>
        <div class="text-center">
          <div class="flex flex-col items-center">
            <h3 class="text-lg font-bold text-gray-700">Ionic Appflow</h3>
          </div>
        </div>
      </div>

      <!-- Comparison Categories -->
      @for (category of comparisonData; track category.category) {
        <div class="mb-8">
          <h4 class="mb-4 text-xl font-bold text-gray-800">
            {{ category.category }}
          </h4>

          @for (feature of category.features; track feature.name) {
            <div
              class="grid grid-cols-3 gap-4 border-b border-gray-100 py-3 transition-colors hover:bg-gray-50"
            >
              <div class="flex items-center">
                <span class="text-base">{{ feature.name }}</span>
              </div>

              <div class="flex items-center justify-center">
                @if (feature.capawesome === true) {
                  <div class="flex items-center gap-1 text-green-600">
                    <tui-icon
                      icon="@tui.check"
                      class="text-green-600"
                    ></tui-icon>
                    <span class="font-medium">Yes</span>
                  </div>
                } @else if (feature.capawesome === false) {
                  <div class="flex items-center gap-1 text-red-600">
                    <tui-icon icon="@tui.x" class="text-red-600"></tui-icon>
                    <span class="font-medium">No</span>
                  </div>
                } @else {
                  <span
                    class="text-center font-medium"
                    [class.text-green-600]="feature.capawesomeAdvantage"
                    [class.text-gray-700]="!feature.capawesomeAdvantage"
                    >{{ feature.capawesome }}</span
                  >
                }
              </div>

              <div class="flex items-center justify-center">
                @if (feature.appflow === true) {
                  <div class="flex items-center gap-1 text-green-600">
                    <tui-icon
                      icon="@tui.check"
                      class="text-green-600"
                    ></tui-icon>
                    <span class="font-medium">Yes</span>
                  </div>
                } @else if (feature.appflow === false) {
                  <div class="flex items-center gap-1 text-red-600">
                    <tui-icon icon="@tui.x" class="text-red-600"></tui-icon>
                    <span class="font-medium">No</span>
                  </div>
                } @else {
                  <span class="text-center font-medium text-gray-700">{{
                    feature.appflow
                  }}</span>
                }
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>

  <div class="flex w-full flex-col items-center gap-2">
    <p class="max-w-2xl text-center text-sm text-gray-500">
      All information has been researched to the best of our knowledge. While we
      strive for accuracy, this comparison might not be exhaustive or fully
      up-to-date. If you notice any inaccuracies, please contact us at
      <a
        href="mailto:support@capawesome.io"
        class="text-primary hover:underline"
        >support&#64;capawesome.io</a
      >
      so we can update it. 💜
    </p>
  </div>
</section>
